import { useState, useEffect } from 'react';
import { GroupedData } from 'components/filtering/filter-logic/GridObject';



export const useGridGrouping = <T>(originData: T[] | undefined | null, groupBy: keyof T) => {

	const [ groupedData, setGroupedData ] = useState<GroupedData<T> | null>(null);

	useEffect(() => {
		if (!originData) {
			setGroupedData(null);
			return;
		};

		if (originData.every(x => typeof x[groupBy] === 'string' || typeof x[groupBy] === 'number')) {
			const sortedOriginData = originData.toSorted((a,b) => (a[groupBy] > b[groupBy]) ? 1 : ((b[groupBy] > a[groupBy]) ? -1 : 0))
			const newGroupedData = Object.groupBy(sortedOriginData, item => {
				const key = item[groupBy];
				if (typeof key === 'string' || typeof key === 'number') {
					return key;
				}
				return 'unknown';
			});
			
			setGroupedData(newGroupedData);
			return;
		}
		
		setGroupedData(null);
		return;
	}, [ originData, groupBy ]);


	return [ groupedData ] as const;
}